import { render, staticRenderFns } from "./Colombia.vue?vue&type=template&id=cb1ba250"
import script from "./Colombia.vue?vue&type=script&lang=js"
export * from "./Colombia.vue?vue&type=script&lang=js"
import style0 from "./Colombia.vue?vue&type=style&index=0&id=cb1ba250&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports